export interface ConcertVenueSection {
  label: string;
  title: string;
  subtitle: string;
  body: string;
  inScope: string[];
  outOfScope?: string[];
  benefits: string[];
}

export const concertVenueSections: ConcertVenueSection[] = [
  {
    label: 'Dedicated venues',
    title: 'VIP and club seating at amphitheaters and pavilions',
    subtitle:
      'In-seat ordering for premium areas — not general-admission lawn sections.',
    body:
      'Many concert venues combine a general-admission lawn with reserved seating, VIP boxes, and club sections. ONI is built for the premium areas where fans have an assigned location — delivering food and beverages directly to VIP, club, and reserved seats without fans leaving their section.',
    inScope: [
      'VIP boxes and suites',
      'Club and premium reserved seating',
      'Reserved bowl and pavilion seats',
    ],
    outOfScope: [
      'Lawn and general-admission areas',
      'Festival fields without seat assignment',
      'GA pits and standing-only zones',
    ],
    benefits: [
      'Premium F&B delivered to club and VIP guests in their seats',
      'Less concession foot traffic in premium sections during shows',
      'Seat-aware routing so runners know exactly where to deliver',
      'Venue controls which premium sections are live per event',
    ],
  },
  {
    label: 'Stadium concerts',
    title: 'Concerts that run like game day',
    subtitle:
      'The same in-seat ordering experience fans get at sporting events — configured for live music.',
    body:
      'When major acts play Bank of America Stadium, Mercedes-Benz Stadium, and similar venues, ONI runs the same platform, live queues, and seat-aware routing as a sporting event. Concessions, runners, multi-vendor ordering, and real-time tracking work the same way — venue teams use one operational playbook across sports and concerts.',
    inScope: [
      'Full stadium seating bowl during concerts',
      'All concession operations and multi-vendor ordering',
      'Same fulfillment workflow and live queue as game day',
    ],
    benefits: [
      'One platform and ops playbook for sports and live music',
      'Concert-specific vendor mix and menu configuration',
      'Real-time fulfillment and revenue tracking per show',
      'Fans order from their seat without missing the performance',
    ],
  },
];
